import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from './Footer';
import Menu from './Menu';
import Login from "./Login";
import Register from "./customer/Register";
import News from "./News";
import ToDo from "./ToDo";
import ChangePassword from './ChangePassword';
import AdminDashboard from "./admin/AdminDashboard";

/* SELLER */
import SellerRegister from "./seller/SellerRegister";
import SellerDetails from "./seller/SellerDetails";
import SellerDashboard from "./seller/SellerDashboard";
import AddProduct from "./seller/AddProduct";
import MyProducts from "./seller/MyProducts";
import EditProduct from "./seller/EditProduct";
import UploadImages from "./seller/UploadImages";
import SellerOrders from "./seller/SellerOrders";
import AddCategories from "./seller/AddCategories";
import SellerDeliveries from "./seller/SellerDeliveries";

/* Driver */
import AddDriver from "./admin/AddDriver";
import DriverDashboard from "./driver/DriverDashboard";

/* CUSTOMER */
import Home from "./customer/Home";
import ProductDetails from "./customer/ProductDetails";
import Cart from "./customer/Cart";
import Checkout from "./customer/Checkout";
import Invoice from "./customer/Invoice";
import EditProfile from "./customer/EditProfile";
import Wishlist from "./customer/Wishlist";
import Orders from "./customer/Orders";
import ProductList from "./customer/ProductList";
import ComparePage from "./customer/ComparePage";
import TrackDelivery from "./customer/TrackDelivery";

/* ADMIN */
import Users from "./admin/Users";
import Products from "./admin/Products";
import AdminOrders from "./admin/AdminOrders";


import PrivateRoute from "./PrivateRoute";
import { AuthProvider } from './context/AuthContext';

function Main() {
  const location = useLocation();

  const hideHeader =
    location.pathname === "/user-login" ||
    location.pathname === "/user-register";
  return (

      <div className="App">
        <AuthProvider>

          {!hideHeader && <Header />}

          <Routes>
            {/* PUBLIC */}
            <Route path="/user-login" element={<Login />} />
            <Route path="/user-register" element={<Register />} />
            <Route path="/seller-register" element={<SellerRegister />} />
            <Route path="/admin-menu" element={<Menu />} />
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<ProductList/>}/>
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/compare" element={<ComparePage/>}/>
            {/* ADMIN */}
            <Route element={<PrivateRoute allowedRoles={['Admin']} />}>
              <Route path="/news" element={<News />} />
              <Route path="/todo" element={<ToDo />} />
              <Route path="/admin" element={<AdminDashboard/>}/>
              <Route path="/admin/users" element={<Users/>}/>
              <Route path="/admin/products" element={<Products/>}/>
              <Route path="/admin/orders" element={<AdminOrders/>}/>

              <Route path="/admin/add-driver" element={<AddDriver/>}/>
            </Route>

                 {/* ================= CUSTOMER ================= */}
              <Route element={<PrivateRoute allowedRoles={["Customer", "Admin"]} />}>


                <Route path="/edit-profile" element={<EditProfile />} />
                <Route path="/change-password" element={<ChangePassword />}  />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/invoice/:orderId" element={<Invoice />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/track-delivery/:orderItemId" element={<TrackDelivery />} />

              </Route>

              {/* ================= SELLER ================= */}
                <Route element={<PrivateRoute allowedRoles={["Seller", "Admin"]} />}>
                  <Route path="/seller" element={<SellerDashboard/>}/>
                  <Route path="/seller/add-category" element={<AddCategories/>}/>
                  <Route path="/seller/add-product" element={<AddProduct/>}/>
                  <Route path="/seller/products" element={<MyProducts/>}/>
                  <Route path="/seller/edit/:id" element={<EditProduct/>}/>
                  <Route path="/seller/upload/:id" element={<UploadImages/>}/>
                  <Route path="/seller/orders" element={<SellerOrders/>}/>
                  <Route path="/seller/details" element={<SellerDetails/>}/>
                  <Route path="/seller/delivery" element={<SellerDeliveries/>}/>


                </Route>
                {/* ================= DRIVER ================= */}
                <Route element={<PrivateRoute allowedRoles={["Driver", "Admin"]} />}>

                  <Route path="/driver/dashboard" element={<DriverDashboard/>}/>
                </Route>
          </Routes>

        </AuthProvider>
        <Footer />
      </div>
  );
}

export default Main;
